

import img2 from "../../images/img2.jpg";
import img3 from "../../images/img3.jpg";
import img4 from "../../images/img4.jpg";
import img5 from "../../images/img5.jpg";
import img6 from "../../images/img6.jpg";
//import img7 from "../.../../images/";
import img8 from "../../images/logo1.png";
import img9 from "../../images/logo2.png";
import img10 from "../../images/logo3.png";


export default [
  {
    sys: {
      id: "1"
    },
    fields: {
      name: "pesores studio",
      slug: "single-economy",
      type: "Kiambu",
      price: 1300,
      size: 200,
      capacity: 3,
      pets: false,
      breakfast: false,
      featured: true,
      description: "pesores studio is located in Ruiru, Kiambu. We offer Mixing, Masteringand Vocal Tracking Services. The Studio covers 800 sq ft with control room, vocalbooth, and guest lounge.",
         extras: [
       
        "Soft, oversized face towels",
        "Full-sized, pH-balanced toiletries",
        "Complimentary refreshments",
        "Adequate safety/security",
        "Internet",
        "Comfortable waiting bay"
      ],
      equipments: [
       
    "A Computer",
    "A DAW/Audio Interface Combo",
    "Microphones",
    "Headphones",
    "Studio Monitors",
    "XLR Cables",
    "A Mic Stand",
    "Pop Filters",
    "Ear Training Software"
      ],
      pastclients: [
       
         "https://facebook.com/dommyi",
        "https:/facebook.com/magdalene.musyoka.9",
        "https://facebook.com/khatsenzia.albina.3",
        
      ],
      images: [
        {
          fields: {
            file: {
              url: img8
            }
          }
        },
        {
          fields: {
            file: {
              url: img2
            }
          }
        },
        {
          fields: {
            file: {
              url: img3
            }
          }
        },
        {
          fields: {
            file: {
              url: img4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "2"
    },
    fields: {
      name: "saskia studio",
      slug: "single-basic",
      type: "kajiado",
      price: 1500,
      size: 250,
      capacity: 1,
      pets: false,
      breakfast: true,
      featured: true,
      description:
        "Just a dope studio. Let me know what you want to do. Up to 30 minute extension for start time if late. Studio time extensions can be discussed before or after the sessions. Engineer/Producer",
      extras: [
       
        "Vocal booth, lounge area, cafe on site, vending machines, internet, A/C, restroom",
        "Full-sized, pH-balanced toiletries",
        "Complimentary refreshments",
        "Adequate safety/security",
        "Internet",
        "Comfortable beds"
      ],
              equipments: [
       
        "A Computer",
    "A DAW/Audio Interface Combo",
    "Microphones",
    "Headphones",
    "Studio Monitors",
    "XLR Cables",
    "A Mic Stand",
    "Pop Filters",
    "Ear Training Software"
      ],
      pastclients: [
       
          "https://facebook.com/dommyi",
        "https:/facebook.com/magdalene.musyoka.9",
        "https://facebook.com/khatsenzia.albina.3",
        
      ],
      images: [
        {
          fields: {
            file: {
              url: img9
            }
          }
        },
        {
          fields: {
            file: {
              url: img2
            }
          }
        },
        {
          fields: {
            file: {
              url: img3
            }
          }
        },
        {
          fields: {
            file: {
              url: img4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "3"
    },
    fields: {
      name: "Tobon's Studio",
      slug: "single-standard",
      type: "eldoret",
      price: 2500,
      size: 300,
      capacity: 5,
      pets: true,
      breakfast: false,
      featured: true,
      description:
        "Top-tier podcast recording studio with the best podcasting gear, including 5 Shure SM7B microphones, and multi-cam 4K video recording. Multiple room set up styles (table or couch), various backdrops, lighting options and more. Every booking includes professional engineer.",
      extras: [
       
        "Soft, oversized face towels",
        "Full-sized, pH-balanced toiletries",
        "Complimentary refreshments",
        "Adequate safety/security",
        "Internet",
        "Comfortable beds"
      ],
      equipments: [
       
         "A Computer",
    "A DAW/Audio Interface Combo",
    "Microphones",
    "Headphones",
    "Studio Monitors",
    "XLR Cables",
    "A Mic Stand",
    "Pop Filters",
    "Ear Training Software"
      ],
      pastclients: [
       
         "https://facebook.com/dommyi",
        "https:/facebook.com/magdalene.musyoka.9",
        "https://facebook.com/khatsenzia.albina.3",
        
      ],
      images: [
        {
          fields: {
            file: {
              url: img10
            }
          }
        },
        {
          fields: {
            file: {
              url: img2
            }
          }
        },
        {
          fields: {
            file: {
              url: img3
            }
          }
        },
        {
          fields: {
            file: {
              url: img4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "4"
    },
    fields: {
      name: "kimosop's studio",
      slug: "single-deluxe",
      type: "nairobi",
      price: 3000,
      size: 400,
      capacity: 7,
      pets: true,
      breakfast: true,
      featured: false,
      description:
        "Each room is acoustically tuned and treated to capture the purest audio, right at the source. Whether you're a pop artist, rock band, hip/hop producer, rapper, singer/songwriter or just someone looking to make some noise, we are ready for any of your production needs.We feature a large control room that is connected to two different live rooms (both excellent for drums), and dialed in to a 192 point patch bay with extensive Class A preamps, and top-tier outboard gear. Our mic selection will get you ANY sound you need.",
      extras: [
       
        "Soft, oversized face towels",
        "Full-sized, pH-balanced toiletries",
        "Complimentary refreshments",
        "Adequate safety/security",
        "Internet",
        "Comfortable beds"
      ],
             equipments: [
       
        "A Computer",
    "A DAW/Audio Interface Combo",
    "Microphones",
    "Headphones",
    "Studio Monitors",
    "XLR Cables",
    "A Mic Stand",
    "Pop Filters",
    "Ear Training Software"
      ],
      pastclients: [
       
          "https://facebook.com/dommyi",
        "https:/facebook.com/magdalene.musyoka.9",
        "https://facebook.com/khatsenzia.albina.3",
        
      ],
      images: [
        {
          fields: {
            file: {
              url: img4
            }
          }
        },
        {
          fields: {
            file: {
              url: img2
            }
          }
        },
        {
          fields: {
            file: {
              url: img3
            }
          }
        },
        {
          fields: {
            file: {
              url: img4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "5"
    },
    fields: {
      name: "Kais Studio",
      slug: "double-economy",
      type: "Kakamega",
      price: 6000,
      size: 300,
      capacity: 12,
      pets: false,
      breakfast: false,
      featured: false,
      description:
        "SSL AWS console, Neumann U67 microphone, Earthworks mics, Townsend Sphere Labs mics, Soyuz mics, BAE/API/SSL preamps, CL1b compressor, 150 square-foot live room, Aviom headphone system, Burl & Lynx converters.",
      extras: [
       
        "Soft, oversized face towels",
        "Full-sized, pH-balanced toiletries",
        "Complimentary refreshments",
        "Adequate safety/security",
        "Internet",
        "Comfortable waiting bay"
      ],
             equipments: [
       
      "A Computer",
    "A DAW/Audio Interface Combo",
    "Microphones",
    "Headphones",
    "Studio Monitors",
    "XLR Cables",
    "A Mic Stand",
    "Pop Filters",
    "Ear Training Software"
      ],
      pastclients: [
       
        "https://facebook.com/dommyi",
        "https:/facebook.com/magdalene.musyoka.9",
        "https://facebook.com/khatsenzia.albina.3",
        
      ],
      images: [
        {
          fields: {
            file: {
              url: img5
            }
          }
        },
        {
          fields: {
            file: {
              url: img3
            }
          }
        },
        {
          fields: {
            file: {
              url: img4
            }
          }
        },
        {
          fields: {
            file: {
              url:img2
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "6"
    },
    fields: {
      name: "muyonga's studio",
      slug: "double-basic",
      type: "Nairobi",
      price: 2500,
      size: 350,
      capacity: 1,
      pets: false,
      breakfast: false,
      featured: false,
      description:
        "***COVID 19 Preparations made between bookings. As a result, our availability is decreased. Please contact us with your requests ASAP. We stock face masks (required in the hallways and outside), hand sanitizer and we wipe down all surfaces between clients. muyonga's studio Sound is a full service recording, production and mixing facility based in the heart of NYC's creative capital, Brooklyn. We are stacked with high end recording, production and monitoring equipment. Our staff producers and engineers develop talent and are advancing their own music projects as artists themselves.Our room is acoustically treated and tuned.We are equipped for podcasting.",
      extras: [
       
        "Soft, oversized face towels",
        "Full-sized, pH-balanced toiletries",
        "Complimentary refreshments",
        "Adequate safety/security",
        "Internet",
        "Comfortable waiting bay"
      ],
             equipments: [
       
         "A Computer",
    "A DAW/Audio Interface Combo",
    "Microphones",
    "Headphones",
    "Studio Monitors",
    "XLR Cables",
    "A Mic Stand",
    "Pop Filters",
    "Ear Training Software"
      ],
     pastclients: [
       
        "https://facebook.com/dommyi",
        "https:/facebook.com/magdalene.musyoka.9",
        "https://facebook.com/khatsenzia.albina.3",
        
      ],
      images: [
        {
          fields: {
            file: {
              url: img6
            }
          }
        },
        {
          fields: {
            file: {
              url: img2
            }
          }
        },
        {
          fields: {
            file: {
              url: img3
            }
          }
        },
        {
          fields: {
            file: {
              url: img4
            }
          }
        }
      ]
    }
  }
  // ,{
  //   sys: {
  //     id: "7"
  //   },
  //   fields: {
  //     name: "double standard",
  //     slug: "double-standard",
  //     type: "double",
  //     price: 3000,
  //     size: 400,
  //     capacity: 2,
  //     pets: true,
  //     breakfast: false,
  //     featured: false,
  //     description:
  //       "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
  //     extras: [
  //      
  //       "Soft, oversized face towels",
  //       "Full-sized, pH-balanced toiletries",
  //       "Complimentary refreshments",
  //       "Adequate safety/security",
  //       "Internet",
  //       "Comfortable waiting bay"
  //     ],
      //    extras: [
       
      //   "Soft, oversized face towels",
      //   "Full-sized, pH-balanced toiletries",
      //   "Complimentary refreshments",
      //   "Adequate safety/security",
      //   "Internet",
      //   "Comfortable waiting bay"
      // ],
      // extras: [
       
      //   "Soft, oversized face towels",
      //   "Full-sized, pH-balanced toiletries",
      //   "Complimentary refreshments",
      //   "Adequate safety/security",
      //   "Internet",
      //   "Comfortable waiting bay"
      // ],
  //     images: [
  //       {
  //         fields: {
  //           file: {
  //             url: img7
  //           }
  //         }
  //       },
  //       {
  //         fields: {
  //           file: {
  //             url: room2
  //           }
  //         }
  //       },
  //       {
  //         fields: {
  //           file: {
  //             url: room3
  //           }
  //         }
  //       },
  //       {
  //         fields: {
  //           file: {
  //             url: room4
  //           }
  //         }
  //       }
  //     ]
  //   }
  // },
  // {
  //   sys: {
  //     id: "8"
  //   },
  //   fields: {
  //     name: "double deluxe",
  //     slug: "double-deluxe",
  //     type: "double",
  //     price: 4000,
  //     size: 500,
  //     capacity: 2,
  //     pets: true,
  //     breakfast: true,
  //     featured: true,
  //     description:
  //       "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
  //     extras: [
  //      
  //       "Soft, oversized face towels",
  //       "Full-sized, pH-balanced toiletries",
  //       "Complimentary refreshments",
  //       "Adequate safety/security",
  //       "Internet",
  //       "Comfortable waiting bay"
  //     ],
  //     images: [
  //       {
  //         fields: {
  //           file: {
  //             url: img8
  //           }
  //         }
  //       },
  //       {
  //         fields: {
  //           file: {
  //             url: room2
  //           }
  //         }
  //       },
  //       {
  //         fields: {
  //           file: {
  //             url: room3
  //           }
  //         }
  //       },
  //       {
  //         fields: {
  //           file: {
  //             url: room4
  //           }
  //         }
  //       }
  //     ]
  //   }
  // },
  // {
  //   sys: {
  //     id: "9"
  //   },
  //   fields: {
  //     name: "family economy",
  //     slug: "family-economy",
  //     type: "family",
  //     price: 3000,
  //     size: 500,
  //     capacity: 3,
  //     pets: false,
  //     breakfast: false,
  //     featured: false,
  //     description:
  //       "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
  //     extras: [
  //      
  //       "Soft, oversized face towels",
  //       "Full-sized, pH-balanced toiletries",
  //       "Complimentary refreshments",
  //       "Adequate safety/security",
  //       "Internet",
  //       "Comfortable waiting bay"
  //     ],
  //     images: [
  //       {
  //         fields: {
  //           file: {
  //             url: img9
  //           }
  //         }
  //       },
  //       {
  //         fields: {
  //           file: {
  //             url: room2
  //           }
  //         }
  //       },
  //       {
  //         fields: {
  //           file: {
  //             url: room3
  //           }
  //         }
  //       },
  //       {
  //         fields: {
  //           file: {
  //             url: room4
  //           }
  //         }
  //       }
  //     ]
  //   }
  // },
  // {
  //   sys: {
  //     id: "10"
  //   },
  //   fields: {
  //     name: "family basic",
  //     slug: "family-basic",
  //     type: "family",
  //     price: 3500,
  //     size: 550,
  //     capacity: 4,
  //     pets: false,
  //     breakfast: false,
  //     featured: false,
  //     description:
  //       "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
  //     extras: [
  //      
  //       "Soft, oversized face towels",
  //       "Full-sized, pH-balanced toiletries",
  //       "Complimentary refreshments",
  //       "Adequate safety/security",
  //       "Internet",
  //       "Comfortable waiting bay"
  //     ],
  //     images: [
  //       {
  //         fields: {
  //           file: {
  //             url: img10
  //           }
  //         }
  //       },
  //       {
  //         fields: {
  //           file: {
  //             url: room2
  //           }
  //         }
  //       },
  //       {
  //         fields: {
  //           file: {
  //             url: room3
  //           }
  //         }
  //       },
  //       {
  //         fields: {
  //           file: {
  //             url: room4
  //           }
  //         }
  //       }
  //     ]
  //   }
  // },
  // {
  //   sys: {
  //     id: "11"
  //   },
  //   fields: {
  //     name: "family standard",
  //     slug: "family-standard",
  //     type: "family",
  //     price: 4000,
  //     size: 600,
  //     capacity: 5,
  //     pets: true,
  //     breakfast: false,
  //     featured: false,
  //     description:
  //       "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
  //     extras: [
  //       "Plush pillows and breathable bed linens",
  //       "Soft, oversized bath towels",
  //       "Full-sized, pH-balanced toiletries",
  //       "Complimentary refreshments",
  //       "Adequate safety/security",
  //       "Internet",
  //       "Comfortable waiting bay"
  //     ],
  //     images: [
  //       {
  //         fields: {
  //           file: {
  //             url: img11
  //           }
  //         }
  //       },
  //       {
  //         fields: {
  //           file: {
  //             url: room2
  //           }
  //         }
  //       },
  //       {
  //         fields: {
  //           file: {
  //             url: room3
  //           }
  //         }
  //       },
  //       {
  //         fields: {
  //           file: {
  //             url: room4
  //           }
  //         }
  //       }
  //     ]
  //   }
  // },
  // {
  //   sys: {
  //     id: "12"
  //   },
  //   fields: {
  //     name: "family deluxe",
  //     slug: "family-deluxe",
  //     type: "family",
  //     price: 5000,
  //     size: 700,
  //     capacity: 6,
  //     pets: true,
  //     breakfast: true,
  //     featured: true,
  //     description:
  //       "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
  //     extras: [
  //       "Plush pillows and breathable bed linens",
  //       "Soft, oversized bath towels",
  //       "Full-sized, pH-balanced toiletries",
  //       "Complimentary refreshments",
  //       "Adequate safety/security",
  //       "Internet",
  //       "Comfortable waiting bay"
  //     ],
  //     images: [
  //       {
  //         fields: {
  //           file: {
  //             url: img12
  //           }
  //         }
  //       },
  //       {
  //         fields: {
  //           file: {
  //             url: room2
  //           }
  //         }
  //       },
  //       {
  //         fields: {
  //           file: {
  //             url: room3
  //           }
  //         }
  //       },
  //       {
  //         fields: {
  //           file: {
  //             url: room4
  //           }
  //         }
  //       }
  //     ]
  //   }
  // },
  // {
  //   sys: {
  //     id: "13"
  //   },
  //   fields: {
  //     name: "presidential",
  //     slug: "presidential-room",
  //     type: "presidential",
  //     price: 6000,
  //     size: 1000,
  //     capacity: 10,
  //     pets: true,
  //     breakfast: true,
  //     featured: true,
  //     description:
  //       "Street art edison bulb gluten-free, tofu try-hard lumbersexual brooklyn tattooed pickled chambray. Actually humblebrag next level, deep v art party wolf tofu direct trade readymade sustainable hell of banjo. Organic authentic subway tile cliche palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin small batch squid gastropub. Pabst pug tumblr gochujang offal retro cloud bread bushwick semiotics before they sold out sartorial literally mlkshk. Vaporware hashtag vice, sartorial before they sold out pok pok health goth trust fund cray.",
  //     extras: [
  //       "Plush pillows and breathable bed linens",
  //       "Soft, oversized bath towels",
  //       "Full-sized, pH-balanced toiletries",
  //       "Complimentary refreshments",
  //       "Adequate safety/security",
  //       "Internet",
  //       "Comfortable waiting bay"
  //     ],
  //     images: [
  //       {
  //         fields: {
  //           file: {
  //             url: room1
  //           }
  //         }
  //       },
  //       {
  //         fields: {
  //           file: {
  //             url: room2
  //           }
  //         }
  //       },
  //       {
  //         fields: {
  //           file: {
  //             url: room3
  //           }
  //         }
  //       },
  //       {
  //         fields: {
  //           file: {
  //             url: room4
  //           }
  //         }
  //       }
  //     ]
  //   }
  // }
];
